import {
  ADVICE_REQUESTS,
  API_ENDPOINT,
  DOCUMENTS,
  LOCATIONS,
  PROPERTY_TYPE_CODES,
  SEARCH_ASSETS,
  USER_CHATS,
  USER_CHAT_ATTACHMENTS,
  USER_CHAT_MESSAGES,
  USER_REQUESTS,
  STRIPE_SESSION,
  USER_INVITATION,
  GET_USER_INVITATION,
  ACCEPT_USER_INVITATION,
  RESEND_USER_INVITATION,
  GET_SETTINGS,
} from "@constants";
import { apiClient } from "../apiClient";

const V2_URLS = [
  ADVICE_REQUESTS,
  LOCATIONS,
  SEARCH_ASSETS,
  USER_CHATS,
  USER_CHAT_MESSAGES,
  USER_CHAT_ATTACHMENTS,
  USER_REQUESTS,
  PROPERTY_TYPE_CODES,
  DOCUMENTS,
  STRIPE_SESSION,
  USER_INVITATION,
  GET_USER_INVITATION,
  ACCEPT_USER_INVITATION,
  RESEND_USER_INVITATION,
  GET_SETTINGS,
];

export const issueRequest = async (url, options = {}) => {
  const Api = V2_URLS.find((v2Url) => url.includes(v2Url) && !url.includes("/download?asset_id"))
    ? API_ENDPOINT.replace(/v1/g, "v2")
    : API_ENDPOINT;

  const fullUrl = `${Api}${url}`;

  return apiClient
    .request({
      url: fullUrl,
      method: options.method || "POST",
      data: options.body,
      params: options.params,
      headers: options.headers,
      responseType: options.responseType,
    })
    .catch((error) => {
      throw error;
    });
};
